export default __webpack_public_path__ + "images/db348c99681c50dce1c4424da203a5b5.png";